import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
import { Ge as h, hi as g, bo as n, M as i, fi as y } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as p } from "./map-7910a3a7-389c4b7b.js";
import { A as m } from "./query-assigned-ba663908-228b08f4.js";
import "./query-24926cff-3eb94bfb.js";
var d = h(_templateObject || (_templateObject = _taggedTemplateLiteral([".beacon-theme-modern-outlook[beacon-tag-name=beacon-byline],.beacon-theme-modern-outlook [beacon-tag-name=beacon-byline],.beacon-theme-modern-outlook[beacon-version=\"3.0.0\"][beacon-tag-name=beacon-byline],.beacon-theme-modern-outlook[beacon-version=\"3.0.0\"] [beacon-tag-name=beacon-byline],.beacon-theme-modern-outlook [beacon-version=\"3.0.0\"][beacon-tag-name=beacon-byline],.beacon-theme-modern-outlook [beacon-version=\"3.0.0\"] [beacon-tag-name=beacon-byline]{--byline-margin: 0;--byline-padding-block-start: 0}\n"]))),
  u = {
    beaconTagName: "beacon-byline",
    zeroAuthorText: "T.Rowe Price",
    get lightDOMStyleID() {
      return "".concat(this.beaconTagName, "-styles");
    }
  },
  f = h(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["[beacon-tag-name=beacon-byline] :is([slot=author]){font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default));color:var(--beacon-system-color-text-standard, var(--beacon-color-text-default))}[beacon-tag-name=beacon-byline] :is([slot=author]) a{color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-default))}[beacon-tag-name=beacon-byline] :is([slot=author]) a:not(:is(:hover,:focus)){text-decoration:none}\n"]))),
  v = h(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([":host{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default));display:flex;margin:var(--hero-override-byline-margin, var(--byline-margin, var(--beacon-unit-atomic)));margin-block:var(--beacon-system-space-cell-free-floating, var(--beacon-unit-atomic));padding-block-start:var(--hero-override-byline-padding-block-start, var(--byline-padding-block-start, var(--beacon-unit-subatomic)))}::slotted([slot=attribution-text]){font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default));display:block;white-space:nowrap}p{margin:0}.beacon-attribution-tag{display:block;margin-inline-end:var(--beacon-reference-space-2, var(--beacon-unit-subatomic));white-space:nowrap}.beacon-author-list{display:block;list-style:none;margin:0;padding-inline-start:0}.beacon-author-list li{display:inline;font-weight:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold))}.beacon-author-list li:not(:last-of-type):after{content:\", \"}\n"])));
var x = Object.defineProperty,
  A = Object.getOwnPropertyDescriptor,
  a = function a(l, t, s, r) {
    for (var e = r > 1 ? void 0 : r ? A(t, s) : t, c = l.length - 1, b; c >= 0; c--) (b = l[c]) && (e = (r ? b(t, s, e) : b(e)) || e);
    return r && e && x(t, s, e), e;
  };
var o = /*#__PURE__*/function (_g) {
  _inherits(o, _g);
  function o() {
    var _this;
    _classCallCheck(this, o);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(o).apply(this, arguments)), _this.beaconTagName = u.beaconTagName, _this.authors = [], _this.attributionText = "By", _this.multiAuthorText = "Multiple authors", _this.multiAuthorUrl = "";
    return _this;
  }
  _createClass(o, [{
    key: "attributionTextSlotChange",
    /** slotChange handler  */value: function attributionTextSlotChange() {
      this.requestUpdate("slottedAttributionText");
    } /** slotChange handler  */
  }, {
    key: "authorSlotChange",
    value: function authorSlotChange() {
      this.requestUpdate("slottedAuthor");
    }
    /**
     * Renders `<li>`s based on the amount of authors passed into the authors attribute
     * @returns html `<li>`s containing each author
     */
  }, {
    key: "renderBylineAuthors",
    value: function renderBylineAuthors() {
      return this.multiAuthorUrl ? n(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<li><a class=\"beacon-author\" href=", ">", "</a></li>"])), this.multiAuthorUrl, this.multiAuthorText) : this.authors.length > 0 ? n(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), p(this.authors, function (t) {
        return n(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["<li><a class=\"beacon-author\" href=\"", "\">", "</a></li>"])), t.bioUrl, t.name);
      })) : n(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["<li><p class=\"beacon-author\">", "</p></li>"])), u.zeroAuthorText);
    }
  }, {
    key: "render",
    value: function render() {
      return n(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([" <slot @slotchange=", " name=\"attribution-text\">\n        <span class=\"beacon-attribution-tag\">", "</span>\n      </slot>\n      <slot @slotchange=", " name=\"author\">\n        <ul class=\"beacon-author-list\" role=\"list\">\n          ", "\n        </ul>\n      </slot>"])), this.attributionTextSlotChange, this.attributionText, this.authorSlotChange, this.renderBylineAuthors());
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(o), "styles", this), v];
    }
  }, {
    key: "lightDOMStyles",
    get: function get() {
      return [_get(_getPrototypeOf(o), "lightDOMStyles", this), f, d];
    }
  }]);
  return o;
}(g(y));
o.tagName = u.beaconTagName;
a([i({
  type: Array,
  alternateSlot: "author",
  sync: !1
})], o.prototype, "authors", 2);
a([i({
  attribute: "attribution-text",
  alternateSlot: "attribution-text",
  sync: !1
})], o.prototype, "attributionText", 2);
a([i({
  attribute: "multi-author-text",
  alternateSlot: "author",
  sync: !1
})], o.prototype, "multiAuthorText", 2);
a([i({
  attribute: "multi-author-url",
  alternateSlot: "author",
  sync: !1
})], o.prototype, "multiAuthorUrl", 2);
a([m({
  slot: "attribution-text",
  flatten: !0
})], o.prototype, "slottedAttributionText", 2);
a([m({
  slot: "author",
  flatten: !0
})], o.prototype, "slottedAuthor", 2);
export { o as BeaconByline };